import { useEffect, useState } from "react";

export const detectDevice = () => {
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipad|ipod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "ios";
  return "desktop";
};

// Phones and tablets, including in-app previews that report a computer browser.
export const isPhone = () =>
  detectDevice() !== "desktop" || (navigator.maxTouchPoints > 0 && Math.min(window.screen.width, window.screen.height) < 768);

// True inside the installed app: iPhone home-screen app, our Android app (TWA referrer), or launched with ?source=app|android|ios.
export const isStandalone = () =>
  window.navigator.standalone === true || document.referrer.startsWith("android-app://org.ishukart.app") ||
  sessionStorage.getItem("ishukart_in_app") === "1";

// Browser "Install app" prompt (Chrome / Edge / Samsung Internet).
export const useInstallPrompt = () => {
  const [prompt, setPrompt] = useState(() => window.__installPrompt || null);
  const [installed, setInstalled] = useState(false);
  useEffect(() => {
    const ready = () => setPrompt(window.__installPrompt || null);
    const done = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("installprompt-ready", ready);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("installprompt-ready", ready); window.removeEventListener("appinstalled", done); };
  }, []);
  const install = async () => {
    if (!prompt) return false;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    window.__installPrompt = null;
    setPrompt(null);
    if (outcome === "accepted") setInstalled(true);
    return outcome === "accepted";
  };
  return { canInstall: !!prompt, install, installed };
};
